import React from 'react'
// libs
import styled from 'styled-components'
import { useRouter } from 'hooks/useRouter'
import { isDesktop } from 'react-device-detect'
// hooks
import { useCurrentUser } from 'hooks/useCurrentUser'
import { useRiskRelatedForms } from 'hooks/risks'
// icons
import EditIcon from '@mui/icons-material/Edit'
import AddIconOrigin from '@mui/icons-material/Add'
// components
import { Button, BUTTON_LAYOUTS, CREATE_BUTTON_STYLE, IconButton } from 'components/UI'
// context
import { RiskAPIContext } from 'containers/Risks/Risk/Edit/layers/API'
import { RiskTemplateAPIContext } from 'containers/Risks/RiskTemplate/Edit/layers/API'
// utils
import get from 'lodash/get'
import { size } from 'polished'

const AddIcon = styled(AddIconOrigin)`
  && {
    ${size('24px')};
  }
`

const MultipleRelatedFormButtons: React.FC = () => {
  const router = useRouter()

  const [isCreating, setIsCreating] = React.useState(false)

  const { createRelatedRisk } = React.useContext(RiskAPIContext)
  const { riskTemplate } = React.useContext(RiskTemplateAPIContext)

  const {
    permissionsFromSecurityGroups: { manageRiskTemplates }
  } = useCurrentUser()

  const { parentRelatedForm: relatedForm } = useRiskRelatedForms()

  const isScheduled = router.query.scheduled === 'true'

  const onEditClick = () => window.open(`/forms/templates/edit/${riskTemplate.id}`, '_blank')

  const onAddClick = () => {
    setIsCreating(true)
    createRelatedRisk(relatedForm, isScheduled).finally(() => setIsCreating(false))
  }

  return (
    <>
      {isDesktop ? (
        <Button
          onClick={onEditClick}
          style={CREATE_BUTTON_STYLE}
          disabled={!manageRiskTemplates}
          layout={BUTTON_LAYOUTS.DARK_BLUE}>
          Edit template
        </Button>
      ) : (
        <IconButton onClick={onEditClick}>
          <EditIcon />
        </IconButton>
      )}

      {isDesktop ? (
        <Button
          onClick={onAddClick}
          isLoading={isCreating}
          style={CREATE_BUTTON_STYLE}
          layout={BUTTON_LAYOUTS.PURPLE}
          disabled={!relatedForm?.permissions.riskCreate}>
          {`${isScheduled ? 'Schedule' : 'Add'} ${get(riskTemplate, 'name', 'Form')}`}
        </Button>
      ) : (
        <IconButton onClick={onAddClick} disabled={isCreating || !relatedForm?.permissions.riskCreate}>
          <AddIcon />
        </IconButton>
      )}
    </>
  )
}

export default MultipleRelatedFormButtons
